import { type ReactNode, useState } from 'react';
import { Button } from '@/components/ui/button';
import type { Creator } from '@/types';
import {
  AcceptFormFields,
  type AcceptFormState,
  initAcceptForm,
  toExtraData,
} from './ai-appeal-accept-form-parts';

type Props = {
  creator: Creator;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: (extraData: Partial<Creator>) => void;
  // Texto del botón de confirmación. Default para el flujo de apelaciones;
  // el flujo de limbo (validar sin apelar) pasa "Corregir y validar".
  confirmLabel?: string;
};

function Footer(p: {
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  label: string;
}): ReactNode {
  return (
    <div className="flex items-center justify-end gap-sm">
      <Button variant="ghost" size="sm" onClick={p.onCancel} disabled={p.isPending}>
        Cancelar
      </Button>
      <Button variant="primary" size="sm" onClick={p.onConfirm} disabled={p.isPending}>
        {p.label}
      </Button>
    </div>
  );
}

// Inline edit-then-confirm form. Initialized with the creator's current
// Type/Category/Sex; admin can override before validating. Confirm sends a
// single atomic PATCH via the parent hook. Reused in two contexts: aceptar
// apelación (default) y validar limbo corrigiendo categoría sin sancionar.
export function AiAppealAcceptForm(p: Props): ReactNode {
  const [form, setForm] = useState<AcceptFormState>(initAcceptForm(p.creator));
  return (
    <div className="flex flex-col gap-sm w-full border-t border-white/[0.06] pt-sm">
      <p className="text-xs text-text-secondary">
        Corrige los datos del creator antes de validar:
      </p>
      <AcceptFormFields form={form} setForm={setForm} />
      <Footer
        isPending={p.isPending}
        onCancel={p.onCancel}
        onConfirm={() => p.onConfirm(toExtraData(form))}
        label={p.confirmLabel ?? 'Aceptar y validar'}
      />
    </div>
  );
}
